// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-page[data-v-5d04e923]{padding:2rem 0;min-height:35rem;text-align:center}.error-page__title[data-v-5d04e923]{margin-top:3rem}.error-page__description[data-v-5d04e923]{color:#51596c;margin-top:.5rem;margin-bottom:3rem}", ""]);
// Exports
module.exports = exports;
